import { useState, useEffect } from 'react';
import { SearchBar } from './Nav';
import { DataDisplay, Dropdown, SearchSelect, Toggle } from './FieldComponents';
import { Plus } from 'lucide-react';
import Modal from './Modal';

export const BillingInvoices = () => {
    const [searchCase, setSearchCase] = useState('');
    const [searchTag, setSearchTag] = useState('');
    const [selectedCase, setSelectedCase] = useState(null);
    const [status, setStatus] = useState(0);
    const [showArchived, setShowArchived] = useState(false);
    const [createInvoice, setCreateInvoice] = useState(false);
    const [invoices, setInvoices] = useState([]);

    const fetchInvoices = async () => {
        try {
            const params = new URLSearchParams();
            if (searchCase) params.append('case_search', searchCase);
            if (searchTag) params.append('tag_search', searchTag);
            if (status > 0) params.append('status', status);
            if (showArchived) params.append('show_archived', '1');

            const response = await fetch(`https://api.casedb.co/invoices.php?${params.toString()}`, {
                credentials: 'include'
            });
            const data = await response.json();
            if (data.success) {
                setInvoices(data.invoices || []);
            }
        } catch (err) {
            console.error('Failed to fetch invoices:', err);
        }
    };

    const createNewInvoice = async () => {
        if (!selectedCase) {
            alert('Please select a case first');
            return;
        }

        try {
            const response = await fetch('https://api.casedb.co/invoices.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    case_id: selectedCase.id,
                    status: 'Editing'
                })
            });
            const data = await response.json();
            if (data.success) {
                fetchInvoices();
                setCreateInvoice(false);
                setSelectedCase(null);
            } else {
                alert('Failed to create invoice: ' + data.message);
            }
        } catch (err) {
            console.error('Failed to create invoice:', err);
            alert('Failed to create invoice. Please try again.');
        }
    };

    useEffect(() => {
        fetchInvoices();
    }, [searchCase, searchTag, status, showArchived]);

    /*return (
        <div className='billing invoices'>
            <div className='invoices-search'>
                <div className='unbilled-search-header'>
                    <SearchBar placeholder='Case Name...' title='Search by Case Name' setSearchQuery={(val) => setSearchCase(val)} expanded={true} />
                    <Dropdown
                        options={['All', 'Editing', 'Final', 'Void', 'Paid', 'Partially Paid', 'Overdue', 'Pending Approval', 'Approved']}
                        placeholder='Invoice Status...'
                        value={status}
                        onChange={(index) => setStatus(index)}
                    />
                    <SearchBar placeholder='Tag...' title='Search by Tag' setSearchQuery={(val) => setSearchTag(val)} expanded={true} />
                    <Toggle
                        label='Show Archived'
                        value={showArchived}
                        onChange={() => setShowArchived(prev => !prev)}
                    />
                </div>
                <button className='action tertiary' onClick={() => setCreateInvoice(true)}><Plus size={18} />Create Invoice</button>
            </div>
            <div className='billing-container'>
                <DataDisplay title='Total Outstanding' value={invoices?.reduce((acc, i) => i?.payment === null, 0)} type='currency' />
                <table className='billing-table table-full default'>
                    <thead>
                        <tr className='default'>
                            <th>Date</th>
                            <th>Case Name</th>
                            <th>Case Type</th>
                            <th>Tags</th>
                            <th>Invoice #</th>
                            <th>Description</th>
                            <th>Total Outstanding</th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoices.filter((i) => i.phase != 'archived' || showArchived).map((i, index) => (
                            <tr key={index} className='default'>
                                <td>{i?.date_added}</td>
                                <td>{i?.case}</td>
                                <td>{i?.case_type}</td>
                                <td>{i?.tags?.join(', ')}</td>
                                <td>{i?.id}</td>
                                <td>{i?.description}</td>
                                <td>{i?.outstanding_amount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {createInvoice && (
                <Modal
                    onClose={() => setCreateInvoice(null)}
                    title="Create Invoice"
                    single
                    footer={(
                        <div className='modal-footer-actions'>
                            <button className='action alt' onClick={() => setCreateInvoice(null)}>Cancel</button>
                            <button className='action' onClick={createNewInvoice}>Save</button>
                        </div>
                    )}
                >
                    <div className='form-group small'>
                        <label className='subtext'>Select Case</label>
                        <SearchSelect
                            value={selectedCase}
                            onChange={setSelectedCase}
                            placeholder="Search for a case..."
                        />
                    </div>
                </Modal>
            )}
        </div>
    );*/

    return (
    <a href='https://casedb.co/accounting' target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
        <button className='action tertiary'>Navigate to the Accounting Portal</button>
    </a>);
};